// Duplicate of util from bff. To be removed when translations available in bff
import slugify from 'slugify';

export const buildSlug = (name: string, locale: string): string =>
  slugify(name, { lower: true, remove: /@/, locale });
